module.exports = "/static/assets/7c417cd2ff5d03f924e0ec8f380ad972.svg";